import { getWebStoreApiClient } from '@gn-audio/core/auth/web-store-api';

export const isLoggedIn = async (): Promise<boolean> => {
  await getWebStoreApiClient().onTokenAcquired;
  const account = getWebStoreApiClient().account;

  return !!account;
};
